var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaisehand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/R/raisehand_solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18.4687V20.6077C22 21.1792 21.5368 21.6424 20.9653 21.6424H19.4864C19.1435 21.6424 18.8656 21.3645 18.8656 21.0216V18.4687C18.8656 18.183 18.6339 17.9514 18.3482 17.9514C18.0625 17.9514 17.8309 18.183 17.8309 18.4687V21.0216C17.8309 21.3645 17.5529 21.6424 17.2101 21.6424H7.39316C6.82171 21.6424 6.35846 21.1792 6.35846 20.6077V16.9998C6.35846 16.695 6.22238 16.4076 5.99737 16.2021C3.5415 13.9587 2 10.7246 2 7.12913C2 5.93685 2.16951 4.7843 2.48565 3.69444C2.60757 3.27416 3.00206 3 3.43966 3H5.21967C6.01324 3 6.52736 3.87084 6.29046 4.62823C6.04351 5.41775 5.91039 6.25783 5.91039 7.12913C5.91039 11.7352 9.63072 15.4692 14.22 15.4692H18.8656C20.9653 15.7268 22 16.6332 22 18.4687ZM14.1787 12.8118C16.8783 12.8118 19.0667 10.6154 19.0667 7.9059C19.0667 5.19645 16.8783 3 14.1787 3C11.4792 3 9.29073 5.19645 9.29073 7.9059C9.29073 10.6154 11.4792 12.8118 14.1787 12.8118Z",
    fill: "#07B2D8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisehand);
export default __webpack_public_path__ + "static/media/raisehand.1051c6eb3b15cd4d80a261c67511973a.svg";
export { ForwardRef as ReactComponent };